module.exports = __webpack_public_path__ + "static/media/dot-hover.1ed1d69d.svg";